import { useState, useEffect } from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import content from "app-content";
import styles from "./index.css";
import Icon from "../Icon";
import getMyAccountUrl from "../../../../services/myAccount/getMyAccountUrl";

const FADE_DURATION = 300;

const useTileFade = isSuccess => {
  const [isFaded, setIsFaded] = useState(false);
  const [displayedIsSuccess, setDisplayedIsSuccess] = useState(false);

  useEffect(() => {
    if (isSuccess) {
      setIsFaded(true);
      const timeout = setTimeout(() => {
        setDisplayedIsSuccess(true);
        setIsFaded(false);
      }, FADE_DURATION);

      return () => clearTimeout(timeout);
    }
  }, [isSuccess]);

  return { isFaded, displayedIsSuccess };
};

const TileIcon = ({ displayedIsSuccess }) => (
  <div className={styles.iconWrapper} aria-hidden="true">
    <Icon
      icon={displayedIsSuccess ? "check" : "notification-bell"}
      className={styles.icon}
    />
  </div>
);

TileIcon.propTypes = {
  displayedIsSuccess: PropTypes.bool.isRequired
};

const TileCopy = ({ displayedIsSuccess }) => (
  <div className={styles.content}>
    <p className={styles.title}>
      {displayedIsSuccess
        ? content.saved_items_stock_marketing_opt_in_prompt_confirmation_title
        : content.saved_items_stock_marketing_opt_in_prompt_title}
    </p>
    <div className={styles.descriptionWrapper}>
      {displayedIsSuccess ? (
        <>
          <p className={styles.description}>
            {
              content.saved_items_stock_marketing_opt_in_prompt_confirmation_body
            }
          </p>
          <a
            href={getMyAccountUrl("/my-account/contact-preferences")}
            className={styles.preferencesLink}
            target="_blank"
            rel="noopener noreferrer"
          >
            {
              content.saved_items_stock_marketing_opt_in_prompt_confirmation_body_hyperlink
            }
          </a>
        </>
      ) : (
        <p className={styles.description}>
          {content.saved_items_stock_marketing_opt_in_prompt_body_short}
        </p>
      )}
    </div>
  </div>
);

TileCopy.propTypes = {
  displayedIsSuccess: PropTypes.bool.isRequired
};

const NotificationsOptInTile = ({
  render,
  className,
  onNotifyMe,
  isSuccess
}) => {
  const { isFaded, displayedIsSuccess } = useTileFade(isSuccess);

  return (
    <div
      className={classnames(className, styles.tileContainer, {
        [styles.tileFaded]: isFaded
      })}
      role="status"
      aria-live="polite"
      aria-atomic="true"
    >
      <div
        className={classnames(styles.tile, {
          [styles.tileSuccess]: displayedIsSuccess
        })}
      >
        {render && render({ className: styles.closeButton })}
        <div className={styles.tileContent}>
          <TileIcon displayedIsSuccess={displayedIsSuccess} />
          <TileCopy displayedIsSuccess={displayedIsSuccess} />
          {!displayedIsSuccess && (
            <button
              type="button"
              className={styles.notifyMeButton}
              onClick={onNotifyMe}
            >
              {content.saved_items_stock_marketing_opt_in_prompt_button}
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

NotificationsOptInTile.propTypes = {
  render: PropTypes.func,
  className: PropTypes.string,
  onNotifyMe: PropTypes.func.isRequired,
  isSuccess: PropTypes.bool
};

export default NotificationsOptInTile;
